import { put } from "redux-saga/effects";
import { FormsService } from "../../../services/forms";
import { TransferFormSubmissionsActionType } from "../types";
import { setTransferIsLoading } from "../actionCreators";

export function* transferWixSubmiisonsSaga({ payload }: TransferFormSubmissionsActionType) {
    try {
        const { compId, formId, instance, fieldsDictionary } = payload;
        yield FormsService.transferSubmissions(instance, compId, formId, fieldsDictionary);
        yield put(setTransferIsLoading({ isLoading: false }));
    } catch (e) {
        console.log("Error in transferWixSubmiisonsSaga", e);
    }
}
